export class ExFactoryCalculationService {
    static componentName = "exFactoryCalculation";

    calculateExFactoryValue(sku: $TSFixMe, exFactoryVolumeForecast: $TSFixMe, isDotPrice: $TSFixMe) {
        let result = [];
        for (let i = 0; i < exFactoryVolumeForecast.length; i++) {
            result.push(sku.forecast.price[i] * exFactoryVolumeForecast[i] * (isDotPrice ? sku.dddFact : 1));
        }
        return result;
    }

    sumExFactory(skus: $TSFixMe) {
        let result: number[] = [];
        if (skus.length > 0) {
            result = _.times(skus[0].values.length, _.constant(0));
        }
        for (const e of skus) {
            for (let i = 0; i < e.values.length; i++) {
                result[i] += e.values[i] ? e.values[i] : 0;
            }
        }
        return result;
    }
}

angular.module("topline.services").service(ExFactoryCalculationService.componentName, ExFactoryCalculationService);